<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名" prop="realName">
                <a-input v-model="queryParam.realName" placeholder="请输入姓名" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="身份证" prop="idCard">
                <a-input v-model="queryParam.idCard" placeholder="请输入身份证" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="昵称" prop="userName">
                <a-input v-model="queryParam.userName" placeholder="请输入昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <!-- 增加详情 -->
      <detail-form
        ref="detailForm"
        @ok="getList"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <img style="width: 48px;height: 48px;" preview="人像面" :src="record.portraitPlane" v-if="record.portraitPlane != null && record.portraitPlane != ''" slot="portraitPlane" slot-scope="text, record">

        <img style="width: 48px;height: 48px;" preview="封面" :src="record.emblemPlane" v-if="record.emblemPlane != null && record.emblemPlane != ''" slot="emblemPlane" slot-scope="text, record">

        <span slot="operation" slot-scope="text, record">
           <a @click="$refs.detailForm.handleUpdate(record, undefined)" v-if="record.isSociety == 1">
            公会详情
          </a>
          <a-divider type="vertical"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.applicationStatus == 0">
            审核
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUserCertification,listUserCertification, delUserCertification } from '@/api/platform/userCertification'
import CreateForm from './modules/CreateForm'
import DetailForm from './modules/DetailForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserCertification',
  components: {
    CreateForm,
    DetailForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        realName: null,
        idCard: null,
        portraitPlane: null,
        emblemPlane: null,
        isSociety: null,
        guildLicense: null,
        settlementAccount: null,
        accountName: null,
        branchName: null,
        branchAdress: null,
        userId: null,
        refusalCause: null,
        applicationStatus: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '昵称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'realName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '身份证',
          dataIndex: 'idCard',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '人像面',
          dataIndex: 'portraitPlane',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "portraitPlane"}
        },
        {
          title: '国徽面',
          dataIndex: 'emblemPlane',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "emblemPlane"}
        },
        {
          title: '是否存在公会',
          dataIndex: 'isSociety',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 0){
              return "否"
            }
            if (value == 1){
              return "是"
            }
          }
        },
        {
          title: '申请状态',
          dataIndex: 'applicationStatus',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 0){
              return "审核中"
            }
            if (value == 1){
              return "已同意"
            }
            if (value == 2){
              return "已拒绝"
            }
          }
        },
        {
          title: '拒绝原因',
          dataIndex: 'refusalCause',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户-实名认证（主播认证）列表 */
    getList () {
      this.loading = true
     pageUserCertification(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        realName: undefined,
        idCard: undefined,
        portraitPlane: undefined,
        emblemPlane: undefined,
        isSociety: undefined,
        guildLicense: undefined,
        settlementAccount: undefined,
        accountName: undefined,
        branchName: undefined,
        branchAdress: undefined,
        userId: undefined,
        refusalCause: undefined,
        applicationStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUserCertification(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('platform/user-certification/export', {
            ...that.queryParam
          }, `用户-实名认证（主播认证）_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
